import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ReportsForToday } from '../../models/report.model';
import { NotifierService } from 'angular-notifier';
import { ReportService } from '../../services/report.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-today-report',
  templateUrl: './today-report.component.html',
  styleUrls: ['./today-report.component.css']
})
export class TodayReportComponent implements OnInit { 
  today: Date;
  refreshTime: Date;
  publishTime: Date;
  postPublish: boolean = false;
  pastPublish: boolean = false;
  noPublish: boolean = false;
  postPublishReport: ReportsForToday[];
  pastPublishReport: ReportsForToday[];
  emptyPlaceHolder: ReportsForToday;
  @Input() todayReportData: ReportsForToday[];
  @Output() refresh = new EventEmitter<any>();

  constructor(private notifier:NotifierService,
    private reportService: ReportService) { 
      
    }

  ngOnInit(): void {
    this.today = new Date();
    this.publishTime = new Date();
    this.refreshTime = new Date();
    //set publish time to 3PM
    this.publishTime.setHours(parseInt(environment.reportPublishTime.split(':')[0]));
    this.publishTime.setMinutes(parseInt(environment.reportPublishTime.split(':')[1]));
    this.publishTime.setSeconds(parseInt(environment.reportPublishTime.split(':')[2]));
    //convert publish time to local time zone
    this.publishTime.setHours((this.publishTime.getHours() + (this.checkDST ? 4 : 5)) - this.publishTime.getTimezoneOffset()/60);
    this.refreshTime.setHours(this.publishTime.getHours() - new Date().getHours());
    this.refreshTime.setMinutes(this.publishTime.getMinutes() - new Date().getMinutes());
    this.refreshTime.setSeconds(this.publishTime.getSeconds() - new Date().getSeconds());
    this.noPublish = false;
    this.postPublish = true;
    this.pastPublish = false;
    if(this.pastPublish){    
        this.todayReportData = this.todayReportData.filter(x=>x.publishedOn!=null);
    }
    if(this.todayReportData?.length > 0){ 
        this.noPublish = false;
    }
    else{
      this.noPublish = true;
    }
    this.setTimer();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.pastPublish){    
      this.todayReportData = this.todayReportData.filter(x=>x.publishedOn!=null);
    }
    if(this.todayReportData?.length > 0){ 
        this.noPublish = false;
        //Adding two empty items at the bottom of carousel to avoid last item been cut out
        var emptyItem = new ReportsForToday();
        emptyItem.reportName = "EmptyPlaceHolder";
        this.todayReportData.push(emptyItem);
        this.todayReportData.push(emptyItem);
    }
    else{
      this.noPublish = true;
    }
  }

  async setTimer(){
    if (new Date() < this.publishTime){
      await new Promise(f => setTimeout(f, 1000));
      this.ngOnInit();
    }
    else{
      this.refresh.emit();
      this.postPublish = false;
      this.pastPublish = true;
    }
  }

  refreshPage() {
    this.refresh.emit();
    this.notifier.notify('success', 'Today\'s report updated.');
  }

  viewReport(reportId){
    this.reportService.previewPDF$(reportId).subscribe((content:Blob)=>{
      const fileURL = URL.createObjectURL(content);
      window.open(fileURL, '_blank');
    });
  }

  checkDST(){
    var january = new Date(this.today.getFullYear(), 0, 1).getTimezoneOffset();
    var july = new Date(this.today.getFullYear(), 6, 1).getTimezoneOffset();
    return Math.max(january, july) != this.today.getTimezoneOffset();
  }
}
